import { render, staticRenderFns } from "./VetOnboarding.vue?vue&type=template&id=f6743e80&"
import script from "./VetOnboarding.vue?vue&type=script&lang=js&"
export * from "./VetOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./VetOnboarding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports